
<div >
  <div class="row ">
    <div class="col pl-3">
      <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Import</h4>
    </div>
  </div>
  <div *ngIf="global.globalAgencyId == null || global.globalAgencyId == undefined || global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == 0|| this.global.globalAgencyId == '' ">
    <div class="row mt-4">
      <div class="col">
        <div class="card border-0 box-shadow">
          <div class="card-body widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4"
  *ngIf="global.globalAgencyId != null && global.globalAgencyId != '' && global.globalAgencyId != undefined && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'">
    <div class="col ">
      <div widget class="card border-0 box-shadow">
        <div class="row ">
          <div class="col ">
            <div class="card-body  widget-body pb-0 pt-2 ">
              <div class="alert alert-warning" *ngIf="onDOCFileChangedErr!= '' " closable
                (close)="onDOCFileChangedErr=''" (click)="onDOCFileChangedErr=''">
                {{onDOCFileChangedErr}}
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close"
                  (click)="onDOCFileChangedErr=''">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="row ">
                <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 mt-1">
                  <div class="custom-file ">
                    <input type="file" [disabled]="global.globalAgencyId==0" class="custom-file-input w-50"
                      id="customFile" #myInput name="filename" (change)="onFileChanged($event.target.files)"
                      [(ngModel)]="filepath" (click)="myInput.value = null">
                    <!-- <label class="custom-file-label" for="customFile">Choose file</label> -->
                  </div>&nbsp;&nbsp;
                </div>
                <div class="col-lg-5"> <button type="button" class="btn blue-btn ml-3 mt-1"
                    [disabled]="selectedFileName =='' " (click)="onDOCFileChanged()"><i
                      class="fa fa-upload fa-lg"></i></button><br>
                </div>
                <div class=" col-lg-2 mt-1">
                  <button type="button" class="btn blue-btn btn-sm" style="float:right"
                    [disabled]="global.globalAgencyId==0" (click)="Refresh()">
                    <i class="fa fa-repeat"> </i>Refresh
                  </button>&nbsp;&nbsp;
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <label class="text-primary">{{selectedFileName}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                    *ngIf="global.globalAgencyId!=0" (resizeStop)="onResize($event)" [allowPaging]='true'
                    [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                    (actionBegin)="onActionComplete($event)" [showColumnChooser]='true' allowTextWrap='true'
                    [textWrapSettings]='wrapSettings' (dataStateChange)='dataStateChange($event)'>
                    <e-columns>
                      <e-column width=100 uid="action" headerText="Action" [showInColumnChooser]='false'>
                        <ng-template #template let-data>
                          <button class="btn btn-edit-table text-center" (click)="viewFile(data)"><i
                              class="fa fa-eye"></i></button>
                        </ng-template>
                      </e-column>
                      <e-column width=100 field="id" headerText="Import Id" type="number"></e-column>
                      <e-column width=100 field="fileName" headerText="File Name" type="string">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column width=100 field="importedDate" headerText="Import Date" type="date"
                        [format]='formatOptions'>
                      </e-column>
                      <e-column width=100 field="importStatus" headerText="Import Status" type="string">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column width=100 field="error" headerText="Error" type="string" [allowSorting]='false'
                        [allowFiltering]='false'>
                      </e-column>
                      <e-column width=100 field="totalAmount" headerText="Total Amount" type="number">
                      </e-column>
                      <e-column width=100 field="traceNumber" headerText="Check Number" type="string" >
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column width=100 field="payor" headerText="Payor" type="string" >
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column width="50" [showInColumnChooser]='false'>
                        <ng-template #headerTemplate let-data>
                          <div class="d-none d-lg-block">
                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                          </div>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                  <div *ngIf="global.globalAgencyId!=0">
                    <div *ngIf="ImportDataList.length == 0" class="text-center" style="color:red">
                      <p>No data available</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<span id="openModal1" data-bs-target="#viewmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog1 modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header1 border-0">
        <h5 class="modal-title text-left font-header">835 Record</h5>
        <button class="text-right btn blue-btn btn-sm ml-3" (click)="kendopdfdownloadList()">
          Download
        </button>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body modal-body1">
        <div class="row">
          <div class="col-lg-12">
            <kendo-pdf-export #pdflist paperSize="A4">
              <div style="width:700px">
                <ng-container *ngFor="let val of Report835">
                  <div class="row">
                    <div class="col-lg-7">
                      <div class="row">
                        <div class="col-lg-4">
                          <label style="font-weight: 600">File Name:</label>
                        </div>
                        <div class="col-lg-8">
                          <label>{{val.fileName}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="row">
                        <div class="col-lg-5">
                          <label style="font-weight: 600">Imported Date:</label>
                        </div>
                        <div class="col-lg-7">
                          <label>{{val?.importedDate |date: "MM/dd/yyyy"}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr style="
                      margin-top: 1.5%;
                      border-top: 1px solid rgb(19, 17, 17);
                      width: 100%;
                      box-shadow: 0px 1px 1px #0c0c0c;
                      " />
                  <div class="row">
                    <div class="col">
                      <b>Total Units:</b> {{this.TotalUnits}}
                    </div>
                  </div>
                  <ng-container *ngFor="let transaction of val.transaction835s">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="font-weight-bold">{{transaction.payorDetail.payorName}}</div>
                        <div class="font-weight-bold">{{transaction.payorDetail.payorStreet}}</div>
                        <div class="font-weight-bold">{{transaction.payorDetail.payorCity}} </div>
                        <div class="font-weight-bold">
                          {{transaction.payorDetail.payorState}},{{transaction.payorDetail.payorZiPCode}} </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="font-weight-bold">{{transaction.companydetails.companyName}}</div>
                        <div class="font-weight-bold">{{transaction.companydetails.companyAddress}}</div>
                        <div class="font-weight-bold">{{transaction.companydetails.companyCity}}</div>
                        <div class="font-weight-bold">
                          {{transaction.companydetails.companyState}},{{transaction.companydetails.companyZip}}</div>
                      </div>
                      <div class="col-lg-4">
                        <div class="font-weight-bold">Payment Method:{{transaction.paymentDetail.payment_Method}}</div>
                        <div class="font-weight-bold">Chk/EFT NBR :{{transaction.paymentDetail.check_EFT_NBR }}</div>
                        <div class="font-weight-bold">Check EFT date:{{transaction?.paymentDetail.chk_EFT_date| date:
                          "MM/dd/yyyy"}}</div>
                        <div class="font-weight-bold">Remittance Amount:{{transaction.paymentDetail.remittance_Amount}}
                        </div>
                      </div>
                    </div>
                    <ng-container *ngFor="let patientClaim of transaction?.patient_ClaimDetails">
                      <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />

                      <div class="row">
                        <div class="col-lg-5">
                          <div class="row">
                            <div class="col-lg-4">
                              <label style="font-weight: 600">Patient:</label>
                            </div>
                            <div class="col-lg-8">
                              <label>{{patientClaim.patient}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="row">
                            <div class="col-lg-4">
                              <label style="font-weight: 600">HIC:</label>
                            </div>
                            <div class="col-lg-8">
                              <label>{{patientClaim.hic}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="row">
                            <div class="col-lg-4">
                              <label style="font-weight: 600">Pat Ctrl:</label>
                            </div>
                            <div class="col-lg-8">
                              <label>{{patientClaim.patCtrl}}</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-5">
                          <div class="row">
                            <div class="col-lg-6">
                              <label style="font-weight: 600">Payor Claim Number:</label>
                            </div>
                            <div class="col-lg-6">
                              <label>{{patientClaim.payor_Claim_Number}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="row">
                            <div class="col-lg-6">
                              <label style="font-weight: 600">From Date:</label>
                            </div>
                            <div class="col-lg-6">
                              <label>{{patientClaim?.fromDate |date: "MM/dd/yyyy"}}</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="row">
                            <div class="col-lg-6">
                              <label style="font-weight: 600">To Date:</label>
                            </div>
                            <div class="col-lg-6">
                              <label>{{patientClaim?.toDate |date: "MM/dd/yyyy"}}</label>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="row w-100">
                        <div class="col-lg-2">
                          Service Date
                        </div>
                        <!-- <div class="col-lg-1">
                          POS
                        </div> -->
                        <div class="col-lg-1">
                          Units
                        </div>
                        <div class="col-lg-1">
                          Service
                        </div>
                        <div class="col-lg-1">
                          MOD
                        </div>
                        <div class="col-lg-1">
                          Billed
                        </div>
                        <div class="col-lg-2">
                          Notes
                        </div>
                        <div class="col-lg-3">
                          DenialDetail
                        </div>
                        <div class="col-lg-1">
                          Payment
                        </div>
                      </div>
                      <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />
                      <ng-container *ngFor="let val1 of patientClaim.serviceLineDetail">
                        <div class="row w-100">
                          <div class="col-lg-1">
                            {{val1.serviceDate|date:'MM/dd/yyyy'}}
                          </div>
                          <div class="col-lg-1">

                          </div>
                          <div class="col-lg-1">
                            {{val1.unit}}
                          </div>
                          <div class="col-lg-1">
                            {{val1.servicecode}}
                          </div>
                          <div class="col-lg-1">
                            {{val1.mod}}
                          </div>
                          <div class="col-lg-1">
                            {{val1.billedAmt}}
                          </div>
                          <div class="col-lg-2 pr-0">
                            {{val1.notes}}
                          </div>
                          <div class="col-lg-3 ">
                            {{val1.denied_Detail}}
                          </div>

                          <div class="col-lg-1">
                            {{val1.claimed_Amt}}
                          </div>
                        </div>
                      </ng-container>
                      <br>
                      <div class="row w-100">
                        <div class="col-lg-2 mt-3">
                          <div class="mt-1">{{patientClaim.patient}}</div>
                        </div>
                        <div class="col-lg-1 mt-1">
                          <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                          {{patientClaim.totalUnit}}
                        </div>
                        <div class="col-lg-1 mt-3">
                          <div class="mt-1"> PtResp:</div>
                        </div>
                        <div class="col-lg-1 mt-3">
                          <div></div>
                          <div class="mt-1"> {{patientClaim.totalPtRespAmt}}</div>
                        </div>
                        <div class="col-lg-1 mt-1">
                          <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                          {{patientClaim.totalBilledAmt}}
                        </div>
                        <div class="col-lg-5">
                        </div>
                        <div class="col-lg-1 ">
                          <hr style="
                              margin-top: 1.5%;
                              border-top: 1px solid rgb(19, 17, 17);
                              width: 100%;
                              text-align: center;
                              box-shadow: 0px 1px 1px #0c0c0c;
                              " />
                          <div> {{patientClaim.totalClaimAmt}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <hr style="
                        margin-top: 1.5%;
                        border-top: 1px solid rgb(19, 17, 17);
                        width: 100%;
                        text-align: center;
                        box-shadow: 0px 1px 1px #0c0c0c;
                        " />
                  </ng-container>
                </ng-container>
              </div>
              <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                <div class="kendofooter">
                  <hr style="
                  margin-top: 1.5%;
                  border-top: 1px solid rgb(19, 17, 17);
                  width: 100%;
                  box-shadow: 0px 1px 1px #0c0c0c;
                  " />
                  <div> Exception notes: Note 1: The full payment was not made on this service line.</div>
                  <div> Note 2: Something has already been paid on this.</div>
                  <div> Note 3: The payment amount is less than zero.</div>
                  <div> Note 4.This is an old format submit claim id, cannot auto-post</div>
                </div>
              </ng-template>
            </kendo-pdf-export>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
